import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-form",
  "use": "icon-form-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-form\"><defs><style type=\"text/css\"></style></defs><path d=\"M511.70816 64.02048c-247.27552 0-447.72864 200.45312-447.72864 447.72352 0 247.27552 200.45312 447.72352 447.72864 447.72352 247.2704 0 447.72352-200.448 447.72352-447.72352C959.43168 264.4736 758.97856 64.02048 511.70816 64.02048zM316.84608 735.61088 209.88416 735.61088l0-127.70304 106.96704 0L316.8512 735.61088zM557.50656 735.61088l-106.9568 0L450.54976 437.64736l106.9568 0L557.50656 735.61088zM798.17216 735.61088l-106.96192 0L691.21024 309.95456l106.96192 0L798.17216 735.61088z\" p-id=\"9849\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/form.svg
// module id = HbpF
// module chunks = 7